import { BoilerAdapter, HeatingCircuit, Pump } from 'z3k-config';
export var DHWControlType;
(function (DHWControlType) {
    DHWControlType["OFF"] = "OFF";
    DHWControlType["BOILER"] = "BOILER";
    DHWControlType["FLOW_DHW"] = "FLOW_DHW";
    DHWControlType["BOILER_PLUS_DHW_BOILER"] = "BOILER_PLUS_DHW_BOILER";
})(DHWControlType || (DHWControlType = {}));
export function guess_dhw_control_type(config, dhw_circuit) {
    if (dhw_circuit.control_devices.length == 0) {
        return DHWControlType.OFF;
    }
    const control_id = dhw_circuit.control_devices[0];
    if (BoilerAdapter.get.byId(config, control_id) != null)
        if (HeatingCircuit.isFlowDHW(dhw_circuit)) {
            return DHWControlType.FLOW_DHW;
        }
        else {
            return DHWControlType.BOILER_PLUS_DHW_BOILER;
        }
    if (Pump.get.byId(config, control_id) != null) {
        return DHWControlType.BOILER;
    }
    return DHWControlType.OFF;
}
